// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"6131227a","7":"8af203fd","303":"3a31e2b8","313":"8df8d7d6","391":"0ea4d88c","453":"d855a71b","504":"29ad68be","638":"4582b384","668":"f7bee6d0","689":"2229af80","720":"3b8c6118","802":"2f719b52"}[chunkId] + ".chunk.js";
};